export default "__VITE_ASSET__BGxeBuXh__"